import React, { Component } from 'react';
// import logo from './logo.svg'

const SvgIcon = () => (<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" fill="#fff"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M1.034 0h11.931C13.537 0 14 .449 14 1.003v11.994C14 13.55 13.537 14 12.965 14H1.035C.462 14 0 13.55 0 12.997V1.003C0 .449.463 0 1.034 0zM2.13 11.72h2.114V5.398H2.13v6.322zm1.057-7.185h-.014c-.709 0-1.168-.486-1.168-1.092 0-.62.473-1.093 1.196-1.093.724 0 1.169.472 1.183 1.093 0 .606-.46 1.092-1.197 1.092zm6.568 7.185h2.114V8.094c0-1.942-1.042-2.845-2.434-2.845-1.122 0-1.625.613-1.906 1.044v-.895H5.414c.028.592 0 6.322 0 6.322h2.114V8.188c0-.19.014-.378.07-.513.153-.377.5-.768 1.085-.768.765 0 1.071.58 1.071 1.429v3.383z" fill="#0077B5"></path></g><defs><clipPath id="a"><path d="M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" fill="#fff"></path></clipPath></defs></svg>)

class LinkedInIcon extends Component {
  render() {
    return (
      <div style={{height:'16px', width: '16px', display: "inline-block"}} className="size">
        <SvgIcon />
      </div>
    );
  }
}

export default LinkedInIcon;







// import React from 'react';
// import SvgIcon from '@material-ui/core/SvgIcon';
// import IconButton from '@material-ui/core/IconButton';

// const styles = {

//     largeIcon: {
//       width: 60,
//       height: 60,
//     },
  
//   };

// export function LinkedInIcon(props) {
//     return (
//         <IconButton>
//             <SvgIcon width="100%" height="100%" style={{ fontSize: "16px" }}>
//                 <g clip-path="url(#a)">
//                     <path d="M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" fill="#fff"></path>
//                     <path fill-rule="evenodd" clip-rule="evenodd" d="M1.034 0h11.931C13.537 0 14 .449 14 1.003v11.994C14 13.55 13.537 14 12.965 14H1.035C.462 14 0 13.55 0 12.997V1.003C0 .449.463 0 1.034 0zM2.13 11.72h2.114V5.398H2.13v6.322zm1.057-7.185h-.014c-.709 0-1.168-.486-1.168-1.092 0-.62.473-1.093 1.196-1.093.724 0 1.169.472 1.183 1.093 0 .606-.46 1.092-1.197 1.092zm6.568 7.185h2.114V8.094c0-1.942-1.042-2.845-2.434-2.845-1.122 0-1.625.613-1.906 1.044v-.895H5.414c.028.592 0 6.322 0 6.322h2.114V8.188c0-.19.014-.378.07-.513.153-.377.5-.768 1.085-.768.765 0 1.071.58 1.071 1.429v3.383z" fill="#0077B5"></path>
//                 </g>
//                 <defs>
//                     <clipPath id="a">
//                         <path d="M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" fill="#fff"></path>
//                     </clipPath>
//                 </defs>
//             </SvgIcon>
//         </IconButton>
//     );
// }


// import React from 'react';
// import IconButton from 'material-ui/IconButton';
// import ActionHome from 'material-ui/svg-icons/action/home';

// const styles = {

//   largeIcon: {
//     width: 60,
//     height: 60,
//   },

// };

// const IconButtonExampleSize = () => (
//   <div>
//     <IconButton
//       iconStyle={styles.largeIcon}

//     >
//       <ActionHome />
//     </IconButton>
//   </div>
// );
